import styled from 'styled-components';

const PageContainer = styled.div`
`;

const BreadcrumbsContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

const BadgeContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
`;

const ColorPickerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export
{ PageContainer,
  BreadcrumbsContainer,
  ColorPickerContainer,
  BadgeContainer };
